import React, { useState, useEffect } from "react";
import { Redirect } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { withRouter } from "react-router";
import { getUserUID, isUserLoggedIn } from "../../../state/user";
import {
  isSaving,
  getBlogs,
  loadUserBlogsAction,
  saveBlogAction
} from "../../../state/blogs";
import Layout from "../../containers/Layout/Layout";
import Loader from "../../atomic/Loader/Loader";
import SavingScreen from "../../atomic/SavingScreen/SavingScreen";
import Confirmation from "../../atomic/Confirmation/Confirmation";
import EditBlog from "../../partials/EditBlog/EditBlog";
var slugify = require("slugify");

export const OneBlogPage = withRouter(({ history, match, location }) => {
  const [deletePopupOpen, setDeletePopupOpen] = useState(false);
  const [publishPopupOpen, setPublishPopupOpen] = useState(false);
  const uid = useSelector(getUserUID);
  const blogs = useSelector(getBlogs);
  const [toList, setToList] = useState(false);
  console.log("NEWWWW BLOOOGS", blogs);
  const saving = useSelector(isSaving);
  const [currentBlog, setCurrentBlog] = useState(null);
  const id = match.params.id;
  const dispatch = useDispatch();
  useEffect(() => {
    if (!blogs) {
      dispatch(loadUserBlogsAction());
    }
  }, []);
  useEffect(() => {
    if (blogs) {
      console.log("LETS SET NEWWWW BLOOOGS", blogs);
      setCurrentBlog(blogs.filter(b => b.id === id)[0] || { id });
    }
  }, [blogs]);

  if (!currentBlog || currentBlog.id !== id) {
    return (
      <Layout>
        <Loader />
      </Layout>
    );
  }
  if (saving) {
    return (
      <Layout>
        <SavingScreen />
      </Layout>
    );
  }
  if (toList) {
    return <Redirect to={"/posts"} />;
  }
  if (currentBlog && currentBlog.deleted) {
    return <Redirect to={"/posts"} />;
  }
  if (deletePopupOpen) {
    return (
      <Confirmation
        question={"Are you sure you want to delete this blog?"}
        onCancel={() => setDeletePopupOpen(false)}
        onOk={() => {
          dispatch(saveBlogAction({ ...currentBlog, status: "deleted" }));
          setDeletePopupOpen(false);
        }}
      />
    );
  }
  if (currentBlog.creator === uid && currentBlog.status !== "published") {
    if (publishPopupOpen) {
      return (
        <Confirmation
          question={"Publishing will submit the post for review."}
          onCancel={() => setPublishPopupOpen(false)}
          onOk={() => {
            dispatch(
              saveBlogAction({ ...currentBlog, status: "review" }, true)
            );
            setPublishPopupOpen(false);
          }}
        />
      );
    }
  }
  return (
    <Layout>
      <EditBlog
        blog={currentBlog}
        uploadFolder={uid + "/blogs/"}
        onCancel={() => setToList(true)}
        onSave={blog => {
          setCurrentBlog(null);
          dispatch(saveBlogAction(blog));
        }}
      />
    </Layout>
  );
});
